<script>
import { ContentLoader } from 'vue-content-loader';

export default {
  name: 'ListDividerLoader',
  components: {
    ContentLoader,
  },
};
</script>
<template>
  <content-loader
    :height="760"
    :width="550"
    :speed="2"
    primaryColor="#f3f3f3"
    secondaryColor="#ecebeb"
  >
    <circle cx="33.06" cy="53.72" r="10.72" />
    <rect x="58.58" y="45.68" rx="5" ry="5" width="294.8" height="13.4" />
    <circle cx="31.72" cy="134.24" r="10.72" />
    <circle cx="33.06" cy="456.34" r="10.72" />
    <rect x="48" y="346.6" rx="5" ry="5" width="226.6" height="NaN" />
    <rect x="61.26" y="527.49" rx="5" ry="5" width="294.8" height="13.4" />
    <rect x="31.15" y="490.73" rx="0" ry="0" width="800" height="4.02" />
    <rect x="411.56" y="418.61" rx="0" ry="0" width="0" height="0" />
    <circle cx="33.06" cy="535.52" r="10.72" />
    <rect x="31.15" y="408.86" rx="0" ry="0" width="800" height="4.02" />
    <rect x="29.8" y="333.71" rx="0" ry="0" width="800" height="4.02" />
    <rect x="32.49" y="254.52" rx="0" ry="0" width="800" height="4.02" />
    <rect x="31.15" y="174" rx="0" ry="0" width="800" height="4.02" />
    <rect x="57.24" y="367.78" rx="5" ry="5" width="294.8" height="13.4" />
    <circle cx="31.72" cy="373.13" r="10.72" />
    <rect x="57.24" y="291.28" rx="5" ry="5" width="294.8" height="13.4" />
    <circle cx="31.72" cy="295.29" r="10.72" />
    <rect x="58.58" y="448.3" rx="5" ry="5" width="294.8" height="13.4" />
    <rect x="57.24" y="208.07" rx="5" ry="5" width="294.8" height="13.4" />
    <circle cx="31.72" cy="214.77" r="10.72" />
    <rect x="29.8" y="92.13" rx="0" ry="0" width="800" height="4.02" />
    <rect x="59.92" y="126.21" rx="5" ry="5" width="294.8" height="13.4" />
    <rect x="26.15" y="580.73" rx="0" ry="0" width="800" height="4.02" />
    <rect x="30.15" y="653.73" rx="0" ry="0" width="800" height="4.02" />
    <rect x="29.15" y="731.73" rx="0" ry="0" width="800" height="4.02" />
    <rect x="27.15" y="800.73" rx="0" ry="0" width="800" height="4.02" />
    <rect x="60.26" y="615.49" rx="5" ry="5" width="294.8" height="13.4" />
    <rect x="60.26" y="688.49" rx="5" ry="5" width="294.8" height="13.4" />
    <rect x="64.26" y="763.49" rx="5" ry="5" width="294.8" height="13.4" />
    <rect x="30.15" y="872.73" rx="0" ry="0" width="800" height="4.02" />
    <rect x="65.26" y="832.49" rx="5" ry="5" width="294.8" height="13.4" />
    <rect x="66.26" y="905.49" rx="5" ry="5" width="294.8" height="13.4" />
    <circle cx="37.06" cy="623.52" r="10.72" />
    <circle cx="37.06" cy="695.52" r="10.72" />
    <circle cx="38.06" cy="771.52" r="10.72" />
    <circle cx="40.06" cy="840.52" r="10.72" />
    <circle cx="39.06" cy="911.52" r="10.72" />
  </content-loader>
</template>



// WEBPACK FOOTER //
// ListDividerLoader.vue?3d8cf569